/**
 * The Symagic Server Assignment entity.
 * @author Tom Verschoore de la Houssaije
 */
import * as tslib_1 from "tslib";
import { EntityQuery, EntityState } from 'breeze-client';
import * as moment from 'moment';
import { Appointment } from '../../domain/helpers/appointment';
/**
 * The Symagic Server Assignment entity.
 */
var Assignment = /** @class */ (function (_super) {
    tslib_1.__extends(Assignment, _super);
    function Assignment() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        /**
         * Reference to demand needed for creating a new assignment.
         * @private
         * @type {Entity}
         */
        _this._$Deployment_Demand = null;
        return _this;
    }
    Object.defineProperty(Assignment.prototype, "TotalTravelTime", {
        /**
         * Gets the sum of the travel time booked on this assignment.
         * @type {string}
         */
        get: function () {
            if (!this.entityAspect || !this.entityAspect.entityManager) {
                return 'PT0S';
            }
            if (this.entityAspect.entityState === EntityState.Added) {
                return 'PT0S';
            }
            var entityQuery = EntityQuery.from('SpendTimeItems').where('Account_Oid', 'equals', this['Oid']);
            var data = this.entityAspect.entityManager.executeQueryLocally(entityQuery);
            var result = moment.duration('PT0S');
            data.forEach(function (item) {
                result.add(item['TravelTime']);
            });
            return result.toISOString();
        },
        /**
         * Sets, nothing only needed for angular binding.
         */
        set: function (value) {
            // Make it a read/write property to enable twoway binding.
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Assignment.prototype, "Amount", {
        /**
         * Gets the amount.
         * @type {number}
         * @memberOf Assignment
         */
        get: function () {
            if (!this.entityAspect || !this.entityAspect.entityManager) {
                return 0;
            }
            if (this.entityAspect.entityState === EntityState.Added ||
                this.entityAspect.entityState === EntityState.Deleted ||
                this.entityAspect.entityState === EntityState.Detached) {
                return 0;
            }
            var value = this.getHoursPerUnitOfTask(this);
            if (value === 0) {
                return 0;
            }
            return Math.round(moment.duration(this.Effort).asHours() / value);
        },
        /**
         * Sets, nothing only needed for angular binding.
         */
        set: function (value) {
            // Make it a read/write property to enable twoway binding.
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Gets the HoursPerUnit value of the Task, needed for calculating amount.
     * @private
     * @param {Entity} item Entity in path to load.
     * @param {string[]} path The property path to load
     * @memberOf Assignment
     */
    Assignment.prototype.getHoursPerUnitOfTask = function (item) {
        var ERR_MSG = 'Assignment.Amount needs the properties Deployment.Demand.Task to be expanded.';
        if (item == null) {
            throw Error(ERR_MSG);
        }
        var property = null;
        switch (item.entityType.shortName) {
            case 'Assignment':
                property = 'Deployment';
                break;
            case 'Deployment':
                property = 'Demand';
                break;
            case 'Demand':
                property = 'Task';
                break;
            case 'Task':
                return moment.duration(item['HoursPerUnit']).asHours();
            default:
                if (this.entityAspect.entityState === EntityState.Modified) {
                    return 0;
                }
                throw Error("ERR_MSG" + '?');
        }
        var next = item[property];
        if (next) {
            return this.getHoursPerUnitOfTask(next);
        }
        if (this.entityAspect.entityState === EntityState.Modified) {
            return 0;
        }
        throw Error(ERR_MSG);
    };
    Object.defineProperty(Assignment.prototype, '$Deployment.Demand', {
        /**
         * Gets, the demand needed for creating a new assignment.
         * @readonly
         * @type {Entity}
         */
        get: function () {
            return this._$Deployment_Demand;
        },
        /**
         * Sets the demand needed to creating a new assignmemt.
         * The demand set is used to set default values for other assignment properties.
         */
        set: function (value) {
            this._$Deployment_Demand = value;
            if (value) {
                this['Start'] = value['Start'];
                this['Finish'] = value['Finish'];
                this['Color'] = value['Color'];
                this['Name'] = value['Task'] ? value['Task']['Name'] : value['Name'];
                this['Customer_Oid'] = value['Customer_Oid'];
                this['SumFactor'] = value['SumFactor'];
            }
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Calculates the effort by factoring the ratio of overlap with a given timeslot.
     * @param {moment.Moment} start The start of the timeslot
     * @param {moment.Moment} finish The finish of the timeslot.
     * @returns {number} The effort ratio in seconds
     */
    Assignment.prototype.overlapEffort = function (start, finish) {
        var factor = this.SumFactor;
        if (factor === 0) {
            return 0;
        }
        if (start.isSameOrAfter(this.Finish)) {
            return 0;
        }
        if (finish.isSameOrBefore(this.Start)) {
            return 0;
        }
        var planStart = moment(this.Start);
        var planFinish = moment(this.Finish);
        var overlapStart = start.isAfter(planStart) ? start : planStart;
        var overlapFinish = finish.isBefore(planFinish) ? finish : planFinish;
        var overlap = moment.duration(overlapFinish.diff(overlapStart)).asSeconds();
        if (this.Appointment) {
            // Geen werk druk planning
            return factor * overlap;
        }
        var effort = moment.duration(this.Effort).asSeconds();
        var duration = moment.duration(planFinish.diff(planStart)).asSeconds();
        if (duration === 0 || (start.isSameOrBefore(this.Start) && finish.isSameOrAfter(this.Finish))) {
            // Ik kan de gehele werkdruk geven want
            // de Assignment valt binnen de getoonde periode
            return factor * effort;
        }
        // Ik geef de fractie (overlap / duration) van de werkdruk want
        // de Assignment is groter dan de getoonde periode.
        return factor * (overlap / duration) * effort;
    };
    return Assignment;
}(Appointment));
export { Assignment };
